import Quagga from '@ericblade/quagga2';
import { displayErrorFeedbackMessage } from './utilities';

class BarcodeScanner
{
    constructor()
    {
        // Search
        this.searchOverlay = document.querySelector('#site-search');
        this.searchForm = document.querySelector('#search-form');
        this.searchInput = document.querySelector('.js-search-form-input');

        // Scanner
        this.barcodeScannerVideo = document.querySelector('.js-barcode-scanner__video');
        this.triggerButton = document.querySelector('.js-barcode-scanner__button');
        this.closeButton = document.querySelector('.js-barcode-scanner__close');

        // Camera selection
        this.cameraSelectionNote = document.querySelector('.js-barcode-scanner__camera-selection--note');
        this.cameraSelectionDropdown = document.querySelector('.js-barcode-scanner__camera-selection--dropdown');

        // Helper
        this.isMobile = orion.getShopViewCode() === 'mobile';
        this.cameraTimeout = null;
    }

    init()
    {
        this.initEvents();
    }

    initEvents()
    {
        this.triggerButton.addEventListener('click', () =>
        {
            this.searchOverlay.classList.remove('active');

            this.handleCameraPermission();
        });

        this.closeButton.addEventListener('click', () =>
        {
            Quagga.stop().then(() => Quagga.CameraAccess.release());
        });

        $('body').on(orion.constants.EventFocusOverlayClicked, () =>
        {
            Quagga.stop().then(() => Quagga.CameraAccess.release());
        });
    }

    async handleCameraPermission()
    {
        try
        {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });

            const devices = await Quagga.CameraAccess.enumerateVideoDevices();

            let deviceId = localStorage.getItem('barcode-scanner-device-id');

            if (!deviceId)
            {
                deviceId = await this.determineDefaultCamera(devices);
            }

            devices.forEach(camera =>
            {
                let option = document.createElement('option');

                option.text = camera.label;
                option.value = camera.deviceId;

                if (camera.deviceId === deviceId)
                {
                    option.selected = true;
                }

                this.cameraSelectionDropdown.appendChild(option);
            });

            stream.getTracks().forEach(track => track.stop());

            this.initScanner(deviceId);

            this.initCameraSelection();
        }
        catch (error)
        {
            displayErrorFeedbackMessage('feedback.camera.required.text.barcode.scanner', '', true);
        }
    }

    handleCameraTimeout()
    {
        this.cameraSelectionNote.classList.add('hidden');

        clearTimeout(this.cameraTimeout);

        this.cameraTimeout = setTimeout(() =>
        {
            this.cameraSelectionNote.classList.remove('hidden');
        }, 10000);
    }

    initCameraSelection()
    {
        this.cameraSelectionDropdown.addEventListener('change', () =>
        {
            const selectedId = this.cameraSelectionDropdown.value;

            localStorage.setItem('barcode-scanner-device-id', selectedId);

            Quagga.stop().then(() => Quagga.CameraAccess.release().then(() =>
            {
                this.initScanner(selectedId);

                this.handleCameraTimeout();
            }));
        });
    }

    async determineDefaultCamera(devices)
    {
        const scoredDevices = [];

        for (const device of devices)
        {
            let score = 0;
            const label = device.label.toLowerCase();

            if (label.includes('ultrawide') || label.includes('macro')) score -= 15;
            if (label.includes('wide')) score -= 10;
            if (label.includes('front')) score -= 5;
            if (label.includes('back') || label.includes('rear') || label.includes('main')) score += 10;

            try
            {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: { deviceId: { exact: device.deviceId } }
                });

                const [track] = stream.getVideoTracks();

                if (track && typeof track.getCapabilities === 'function')
                {
                    try
                    {
                        const capabilities = track.getCapabilities();

                        if ('focusDistance' in capabilities) score += 5;
                        if (capabilities.zoom && capabilities.zoom.max > 1) score += 8;
                        if (capabilities.focusMode && (capabilities.focusMode.includes('continuous')
                            || capabilities.focusMode.includes('manual'))) score += 10;
                    }
                    catch (error)
                    {
                        console.warn(error);
                    }
                }

                stream.getTracks().forEach(track => track.stop());
            }
            catch (error)
            {
                console.warn(error);
            }

            scoredDevices.push({ device, score });
        }

        const [best] = scoredDevices.sort((a, b) => b.score - a.score);

        return best && best.device && best.device.deviceId ? best.device.deviceId : devices[0].deviceId;
    }

    initScanner(deviceId)
    {
        let lastCode = null;
        let matchCount = 0;
        const requiredMatches = 5;

        setTimeout(() =>
        {
            Quagga.init({
                inputStream: {
                    name: 'Live',
                    type: 'LiveStream',
                    target: this.barcodeScannerVideo,
                    constraints: {
                        facingMode: { ideal: 'environment' },
                        width: { ideal: 1920 },
                        height: { ideal: 1080 },
                        deviceId: { exact: deviceId }
                    },
                    area: {
                        top: this.isMobile ? '42%' : '37%',
                        right: this.isMobile ? '9%' : '18%',
                        left: this.isMobile ? '9%' : '18%',
                        bottom: this.isMobile ? '42%' : '37%'
                    },
                },
                decoder: {
                    readers: ['ean_reader', 'upc_reader'] // 'ean_8_reader'
                },
                locator: {
                    patchSize: 'small',
                    halfSample: true
                }
            }, (err) =>
            {
                if (err)
                {
                    console.error(err);

                    return;
                }

                Quagga.start();
            });

            this.handleCameraTimeout();

            Quagga.onDetected((result) =>
            {
                const { code } = result.codeResult;

                if (code === lastCode)
                {
                    matchCount++;
                }
                else
                {
                    lastCode = code;
                    matchCount = 1;
                }

                if (matchCount >= requiredMatches)
                {
                    Quagga.offDetected();

                    this.searchInput.value = code;

                    this.searchForm.submit();

                    $('body').trigger(orion.constants.EventFocusOverlayClicked);
                }
            });
        }, 200);
    }
}

const barcodeScanner = new BarcodeScanner();

barcodeScanner.init();
